import _sha1 from 'hash.js/lib/hash/sha/1';
import { take } from 'lodash';
import { stringify } from './strings/stringify';
import { toString } from './strings/toString';

/**
 * To string helper
 * @param data
 * @returns {string}
 * @private
 */
const _toString = (data: any): string => {
    if (data && typeof data === 'object') {
        return stringify(data);
    }

    return toString(data);
};

/**
 * HashString
 * @param data
 * @param first
 * @return {string}
 */
export const sha1 = (data?: any, first?: number): string => {
    const hash = _sha1().update(_toString(data)).digest('hex');
    return take(hash, first || hash.length).join('');
};

/**
 * Hash function {alias}
 */
export const hash = sha1;
